import React from "react";
import { connect } from "react-redux";
import { fromJS } from "immutable";

import { getLauncherOpen, toggleModal } from "data/giving-form-launcher";

import GivingForm from "shared/components/giving-form";

export class GivingFormLauncher extends React.Component {
  state = {
    open: false,
  };

  handleClose = () => {
    const { toggleModal } = this.props;

    toggleModal(false);

    this.setState({
      open: false,
    });

    // clean up sharewizard modal
    if ($("#shareWizard").length > 0) {
      $("#fadedBackground").hide();
      $("#shareWizard .close-share-wizard").hide();
      $("#shareWizard").css("top", "0");
      $("#shareWizard").css("position", "relative");
      $("body").css("overflow", "visible");
      $("body").css("position", "");
    }

    // clean up sharewizard modal
    if ($("#donate-wizard").length > 0) {
      $("#fadedBackground").hide();
      $("#donate-wizard .close-donate-wizard").hide();
      $("#donate-wizard").css("top", "0");
      $("#donate-wizard").css("position", "relative");
      $("body").css("overflow", "visible");
      $("body").css("position", "");
    }
  };

  render() {
    const { campaign, isOpen, launchLocation } = this.props;

    if (!isOpen) return null;

    return (
      <GivingForm
        launchLocation={launchLocation}
        campaign={campaign}
        autoLaunchOn={() => true}
        onClose={this.handleClose}
        markup={"<div class='hidden'></div>"}
        dontPreselectCampaign={campaign.get("shell_campaign")}
        shellCampaign={campaign.get("shell_campaign")}
      />
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    isOpen: getLauncherOpen(state),
    campaign: fromJS(ownProps.campaign),
  };
};

const actionCreators = {
  toggleModal,
};

export default connect(mapStateToProps, actionCreators)(GivingFormLauncher);
